import * as Accordion from '@radix-ui/react-accordion'
import { ChevronDownIcon } from '@radix-ui/react-icons'
import { toolDescriptions } from 'mcp-server/toolDescriptions'
import { resources } from '../../../mcp-server/src/resource'

export default function App() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="w-full max-w-xl mx-auto px-4 py-8">
        <h1 className="text-5xl mb-12 text-white">Convex MCP Server</h1>
        <h2 className="text-xl font-bold mb-4 text-white">Available tools</h2>
        <Accordion.Root type="single" collapsible className="w-full space-y-4">
          {Object.values(toolDescriptions).map((tool) => (
            <Accordion.Item key={tool.name} value={tool.name} className="border border-gray-700 rounded-lg overflow-hidden">
              <Accordion.Header>
                <Accordion.Trigger className="group w-full flex justify-between items-center font-mono text-lg bg-gray-800 text-white px-4 py-3 focus-visible:outline-none focus:bg-gray-700 data-[state=open]:bg-gray-700">
                  <span>{tool.name}</span>
                  <ChevronDownIcon className="ml-2 h-5 w-5 transition-transform duration-300 group-data-[state=open]:rotate-180" />
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className=" bg-gray-900 text-gray-300 text-base AccordionContent">
                <p className="p-4 leading-relaxed">{tool.description}</p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
        <h2 className="text-xl font-bold mb-4 text-white">Available resources</h2>
        <Accordion.Root type="single" collapsible className="w-full space-y-4">
          {Object.values(resources).map((resource) => (
            <Accordion.Item key={resource.name} value={resource.name} className="border border-gray-700 rounded-lg overflow-hidden">
              <Accordion.Header>
                <Accordion.Trigger className="group w-full flex justify-between items-center font-mono text-lg bg-gray-800 text-white px-4 py-3 focus-visible:outline-none focus:bg-gray-700 data-[state=open]:bg-gray-700">
                  <span>{resource.name}</span>
                  <ChevronDownIcon className="ml-2 h-5 w-5 transition-transform duration-300 group-data-[state=open]:rotate-180" />
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className=" bg-gray-900 text-gray-300 text-base AccordionContent">
                <p className="p-4 leading-relaxed">{resource.description}</p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </div>
    </div>
  )
}
